<!--
 * @Description:
 * @Author: Lynn Qin
 * @Date: 2021-04-12 16:25:13
 * @LastEditTime: 2021-12-16 15:30:14
-->
<template lang="pug">
    .pgc-sidebar
        .menu-box
            .pgc-menu
                .pgc-sub-menu(v-for="(itemSub, index) in showRoutes" :key="itemSub.id")
                    .pgc-sub-title(@click="submenuFn(itemSub, index)" :class="[itemSub.isOpen ? 'is-opened' : '', choosedIndex === index ? 'link-index': '']")
                        img.submenu-img(:src='itemSub.iconPath' v-if="itemSub.iconPath")
                        span {{$t(itemSub.i18name)}}
                        img.submenu-icon-arrow(v-if="itemSub.children && itemSub.children.filter(item => !item.hidden).length" src="@/assets/icon/arrow.png")
                    Pgc-Collapse-Transition
                        .menu-item(v-show="itemSub.isOpen && itemSub.children && itemSub.children.length")
                            .pgc-menu-item(v-for="(item, index) in itemSub.children" :key="item.id" v-if="!item.hidden" @click="linkTo(item.path)" :class="[$route.path === item.path ? 'active-item': '']") {{$t(item.i18name)}}

</template>

<script>
import { Menu, MenuItem } from 'element-ui'
import { routes } from '@/router/routes'
import PgcCollapseTransition from '@/utils/collapse-transition.js';
import { cloneDeep } from 'lodash'

export default {
    name: 'pgc-sidebar',
    components: {
        [Menu.name]: Menu,
        [MenuItem.name]: MenuItem,
        PgcCollapseTransition
    },
    data() {
        return {
            hoverItemPath: '',
            isCollapse: false,
            show: true,
            showRoutes: cloneDeep(routes[0].children)
        }
    },
    computed: {
        defaultActive() {
            return '/' + this.$route.path.split('/').reverse()[0]
        },
        choosedIndex() {
            let index =  this.findSubIndex()
            return index >= 0 ? index : 0
        }

    },
    watch: {
        '$route.path'(){
            this.init()
        },
    },
    created() {
        this.init()
    },
    methods: {
        init(){
            let item =  this.showRoutes[this.choosedIndex]
            if(item.children && item.children.length){
                item.isOpen =  true
            }
            // this.scalingFn(item)
        },
        findSubIndex(){
            return this.showRoutes.findIndex(item => {
                if(item.name === this.$route.name){
                    return true
                }
                if(item.children && item.children.length){
                    let index = item.children.findIndex(itemChild => {
                        return itemChild.name === this.$route.name
                    })
                    if (index >= 0) {
                        return true
                    }
                }
                return false
            })
        },
        submenuFn(itemSub,index){
            if(itemSub.children && itemSub.children.filter(item => !item.hidden).length){ 
                if(this.choosedIndex !== index && !itemSub.isOpen){ // 未展开状态
                    this.linkTo(itemSub.path)
                }
                itemSub.isOpen = !itemSub.isOpen
                this.showRoutes = [...this.showRoutes]
            } else {
                if(itemSub.redirect === this.$route.path){
                    return
                }
                this.linkTo(itemSub.path)
            }
            
        },
        scalingFn(itemSub) { //保留只展开一个的方式
            this.showRoutes.forEach((item) => {
                if(item.id !== itemSub.id && !!item.isOpen){
                    item.isOpen = false
                }
            });
            this.showRoutes = [...this.showRoutes]
        },
        linkTo(path){
            if(path === this.$route.path){
                return
            }
            this.$router.push(path)
        }
    }
}
</script>

<style scoped lang="scss">
.pgc-sidebar {
    height: 100%;
    background-color: #F9EBDA;
    .menu-box {
        padding: 0 0px 10px 0px;
        .pgc-menu{
            .pgc-sub-menu{
                .pgc-sub-title,.pgc-menu-item{
                    line-height: 50PX;
                    color: #945100;
                    font-size: 14px;
                    cursor: pointer;
                    user-select: none;
                }
                .pgc-sub-title{
                    padding-left: 25px;
                    img{
                        width: 18px;
                    height: 18px;
                    }
                    &:hover{
                        color: #e48512;
                    }
                }
                .active-item{
                    background: #F7D5AD;
                }
                .link-index{
                    background: #FFB863;
                    color: #fff;
                    &:hover{
                        color: #fff;
                    }
                    .submenu-img, .submenu-icon-arrow{
                        filter: brightness(0) invert(1);
                    }

                }
                .pgc-menu-item{
                    padding-left: 52px;
                    &:hover{
                        color: #e48512;
                    }
                }
                .submenu-img{
                    margin: -2px 6px 0 0;
                }
                .submenu-icon-arrow {
                    transform:rotate(0deg);
                    transform-origin: center center;
                    transition: transform .3s;
                }
                .is-opened {
                    .submenu-icon-arrow {
                        transform:rotate(180deg);
                    }
                    // .submenu-img, .submenu-icon-arrow{
                    //     filter: brightness(0) invert(1);
                    // }
                }
            }
        }
    }
}
</style>
